import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useClientsStats() {
  return useQuery({
    queryKey: ["clients", "stats"],
    queryFn: () => api.clientsStats(),
    staleTime: 5 * 60_000, // 5 min
  });
}
